// extracted by mini-css-extract-plugin
export default {"backdrop":"PopUp_backdrop__EyQb2","card":"PopUp_card__7AxhH","button":"PopUp_button__y8hJ7","buttonToSurvey":"PopUp_buttonToSurvey__Zmm-3"};